export default __webpack_public_path__ + "static/media/cu.60dc993b.svg";